import { cn } from "@/lib/utils";

// @ts-ignore
import contractorIllustration from "../../../assets/ilustraciones/contratista.svg";
// @ts-ignore
import supplierIllustration from "../../../assets/ilustraciones/proveedor.svg";

export type Segment = "contractor" | "supplier";

const SEGMENTS: Array<{
  key: Segment;
  icon: React.ReactNode;
  title: string;
  detail: string;
  pill: string;
  panelClass: string;
  pillClass: string;
}> = [
  {
    key: "contractor",
    icon: <Illustration src={contractorIllustration} />,
    title: "Le vendo al Estado",
    detail: "Postulo a licitaciones de obras, bienes o servicios y quiero saber dónde califico.",
    pill: "Postula solo donde calificas",
    // El mismo tono del círculo de la ilustración, para que se funda con el panel.
    panelClass: "bg-[#E3ECF8]",
    pillClass: "bg-blue-50 text-blue-800",
  },
  {
    key: "supplier",
    icon: <Illustration src={supplierIllustration} />,
    title: "Soy proveedor",
    detail: "Vendo materiales, insumos o servicios a quien gana la obra.",
    pill: "Véndele a quien ganó la obra",
    panelClass: "bg-[#E3F6EC]",
    pillClass: "bg-emerald-50 text-emerald-700",
  },
];

function Illustration({ src }: { src: string }) {
  return <img src={src} alt="" className="h-full w-auto" />;
}

/** Primera pantalla: cómo va a usar LicitiGo. Decide qué flujo sigue. */
export function SegmentStep({ onSelect }: { onSelect: (segment: Segment) => void }) {
  return (
    <div className="my-auto text-center">
      <h1 className="text-[32px] font-extrabold leading-[1.05] tracking-[-0.035em] text-slate-900 sm:text-[46px]">
        ¿Cómo vas a usar LicitiGo?
      </h1>
      <p className="mt-3 text-[15px] text-slate-500">
        Te mostramos solo lo que te sirve.
      </p>

      <div className="mx-auto mt-8 grid max-w-[720px] gap-4 text-left sm:mt-10 md:grid-cols-2">
        {SEGMENTS.map((segment) => (
          <button
            key={segment.key}
            type="button"
            onClick={() => onSelect(segment.key)}
            className="group flex cursor-pointer flex-col rounded-[22px] border border-slate-200 bg-white p-4 text-left shadow-[0_8px_24px_-12px_rgba(15,23,42,0.18)] transition-all hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-[0_14px_32px_-14px_rgba(15,23,42,0.28)]"
          >
            <span
              className={cn(
                "flex h-28 items-center justify-center overflow-hidden rounded-[16px] pt-2 sm:h-36",
                segment.panelClass,
              )}
            >
              {segment.icon}
            </span>
            <span className="mt-4 text-[21px] font-extrabold tracking-[-0.02em] text-slate-900">
              {segment.title}
            </span>
            <span className="mt-1.5 text-[14px] leading-[1.5] text-slate-500">
              {segment.detail}
            </span>
            <span
              className={cn(
                "mt-4 self-start rounded-full px-3 py-1.5 text-[12.5px] font-bold",
                segment.pillClass,
              )}
            >
              {segment.pill}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
